import { Link } from "react-router-dom";
import { IMenuItem } from "../types";

type Props = IMenuItem & {
  selected?: boolean;
  isOpened?: boolean;
  onClick?: () => void;
};

export const MenuItem: React.FC<Props> = ({ route, literal, Icon, selected, isOpened, onClick }) => {
  const item = (
    <div
      onClick={onClick}
      title={!isOpened ? literal : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 11,
        padding: isOpened ? "9px 12px" : "9px 0",
        justifyContent: isOpened ? "flex-start" : "center",
        borderRadius: 8,
        cursor: "pointer",
        position: "relative",
        background: selected ? "rgba(255,255,255,0.08)" : "transparent",
        borderLeft: selected ? "2px solid #e2e8f0" : "2px solid transparent",
        transition: "background 0.15s, border-color 0.15s",
        userSelect: "none",
      }}
      onMouseEnter={e => {
        if (!selected) e.currentTarget.style.background = "rgba(255,255,255,0.05)";
      }}
      onMouseLeave={e => {
        if (!selected) e.currentTarget.style.background = "transparent";
      }}
    >
      <Icon
        style={{
            width: 17,
            height: 17,
          color: selected ? "#f1f5f9" : "#64748b",
          flexShrink: 0,
          transition: "color 0.15s",
        }}
      />
      {isOpened && (
        <span style={{
          fontSize: 13,
          fontWeight: selected ? 600 : 400,
          color: selected ? "#f1f5f9" : "#94a3b8",
          fontFamily: "Poppins, sans-serif",
          whiteSpace: "nowrap",
          transition: "color 0.15s",
        }}>
          {literal}
        </span>
      )}
    </div>
  );

  return route ? <Link to={route} style={{ textDecoration: "none" }}>{item}</Link> : item;
};